import Stack from '@mui/material/Stack'
import Switch from '@mui/material/Switch'
import * as React from 'react'
import { CardTitleDescription } from '../../../../components/CardTitleDescription'
import { useRequestsStore } from '../../../../store/storeRequests'

export const RagSettingCard = () => {
    const {
        updateRequest,
        requestDetail,
        isLoadingUpdateRequest,
        setRequestSettingRagEnabled,
        requestSettingRagEnabled,
    } = useRequestsStore((state) => state)

    const [rag, setRag] = React.useState(
        requestDetail?.id ? requestDetail?.rag_enabled : requestSettingRagEnabled,
    )

    const handelClickEdit = async (event: React.ChangeEvent<HTMLInputElement>) => {
        await setRag(event.target.checked)
        if (requestDetail?.id) {
            await updateRequest(
                { threadId: requestDetail.id },
                {
                    rag_enabled: event.target.checked,
                },
            )
        } else {
            setRequestSettingRagEnabled(event.target.checked)
        }
    }

    return (
        <>
            <CardTitleDescription
                size={{ xs: 12, md: 6 }}
                title="RAG (Retrieval-Augmented Generation)"
                description="Повышает точность ответа, обогащает запрос релевантной информацией из базы данных ARHIASSISTANT"
                isBorder={true}>
                <Stack
                    direction="row"
                    sx={{ alignItems: 'center', justifyContent: 'flex-end', mt: 4 }}>
                    <Switch
                        size="small"
                        checked={rag}
                        onChange={handelClickEdit}
                        disabled={isLoadingUpdateRequest}
                    />
                </Stack>
            </CardTitleDescription>
        </>
    )
}
